export default "__VITE_ASSET__4419bd23__"